export function accountCurrencies(accounts = []) {
  return [...new Set((accounts || []).map((account) => account.currency_code).filter(Boolean))];
}

export function accountsInCurrency(accounts = [], currency) {
  if (!currency) return [];
  return (accounts || []).filter((account) => account.currency_code === currency);
}

export function uniqueAccountInCurrency(accounts, currency) {
  const matches = accountsInCurrency(accounts, currency);
  return matches.length === 1 ? matches[0] : null;
}

export function validSubscriptionAccountId(matches = [], storedAccountId) {
  if (!storedAccountId) return null;
  return matches.some((account) => account.id === storedAccountId) ? storedAccountId : null;
}

export function plansForCustomerAccounts(plans = [], accounts = []) {
  const currencies = new Set(accountCurrencies(accounts));
  return (plans || []).filter((plan) => currencies.has(plan.currency));
}

export function cobrosLocked(competition) {
  return Boolean(competition?.published) || Number(competition?.signups_count) > 0;
}

export function cobrosLockReasonId(competition) {
  if (competition?.published) return "El evento ya está publicado";
  if (Number(competition?.signups_count) > 0) return "Ya hay inscripciones";
  return null;
}
